// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../u... Remove this comment to see the full error message
import useShortlinkParams from '../utils/hooks/useShortlinkParams';
import { Application } from 'foundations-components/components/Application';
import { Flex } from 'foundations-components/components/Flex';
import MarketingNav from 'marketplace-ui-common/components/MarketingNav';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppShortlink, getPublicRootUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export default function PublicApplication({
  children,
  name
}) {
  const {
    pathname,
    search
  } = useLocation();
  const shortlinkParams = useShortlinkParams();
  const marketingNavLocation = useMemo(() => ({
    pathname: `${getPublicRootUrl()}${pathname}`,
    search
  }), [pathname, search]);
  return /*#__PURE__*/_jsx(Application, {
    name: name,
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      children: /*#__PURE__*/_jsx(MarketingNav, {
        location: marketingNavLocation,
        loginUrl: getAppShortlink(pathname, shortlinkParams),
        children: /*#__PURE__*/_jsx("div", {
          style: {
            flex: 1,
            minHeight: '100vh'
          },
          children: children
        })
      })
    })
  });
}